import React, {Component} from 'react';
import PropTypes from 'prop-types';

class ContactUsForm extends Component {
    render() {
        return (
            <div>
                <form name="contact" method="POST" data-netlify="true" action={this.props.forwardTo}>
                    <input type="hidden" name="form-name" value="contact" />
                    <div className="form-group">
                        <label>Full name</label>
                        <input type="text" className="form-control" id="full-name" name="full-name"
                               placeholder="Jon Smith"/>
                    </div>
                    <div className="form-group">
                        <label >Email address</label>
                        <input type="email" className="form-control" id="email" name="email"
                               placeholder="jon.smith@gmail.com"/>
                    </div>
                    <div className="form-group">
                        <label >Subject</label>
                        <input type="text" className="form-control" id="subject" name="subject"
                               placeholder=""/>
                    </div>
                    <div className="form-group">
                        <label >Interest</label>
                        <select className="form-control" name="interest" id="interest" >
                            <option value="Photography">Aerial Photography</option>
                            <option value="Residental-Real-Estate" selected="true">Residential Real Estate</option>
                            <option value="Commercial-Real-Estate">Commercial Real Estate</option>
                            <option value="Roof-Inspection">Roof Inspection</option>
                            <option value="Bridge-Infrastructure-Inspection">Bridge &amp; Infrastructure Inspection</option>
                            <option value="Wind-Solar-Inspection">Wind &amp; Solar Inspection</option>
                            <option value="Construction">Construction</option>
                            <option value="Agriculture">Agriculture</option>
                            <option value="Other">Other</option>
                        </select>
                    </div>
                    <div className="form-group">
                        <label >Message</label>
                        <textarea id="message" name="message" className="form-control" rows="3"></textarea>
                    </div>

                    <button type="submit" className="btn btn-default">Submit</button>
                </form>
            </div>
        );
    }
}

ContactUsForm.propTypes = {
    forwardTo: PropTypes.string,
};

export default ContactUsForm;
